<template>

  <div class="box-container">

    <div class="box">
      <slot>
        <p>Complete 5 virtual training sessions live with one of our SUPER Coaches</p>
      </slot>
    </div>
    <div class="box">
      <slot>
        <p>Earn you Kickboxology certification with our self-guided online course.
          </p>
      </slot>
    </div>
    <div class="box ">
      <slot>
        <p>Enjoy your certification for 90 days with the option to renew</p>
      </slot>
    </div>
  </div>
<p style="font-size: small;">* Kickboxology is accredited by top fitness organizations—earn CECs through the C.O.A.C.H. program. See FAQs for details.</p>
</template>

<style scoped>
.box-container {
  display: flex;
  justify-content: center;
  gap: 20px;
  /* adds space between boxes */
  margin: 20px 0;
  flex-wrap: wrap;
  /* so they stack on smaller screens */
}

.box {
  flex: 1 1 30%;
  /* each box takes ~30% of row */
  max-width: 320px;
  min-width: 250px;
  height: 280px;

  background-image: url('https://res.cloudinary.com/ilovekickboxing/image/upload/v1//Outline_Box_Check_opmhzu.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  padding: 40px 20px 20px;
}


.box p {
  font-size: 16px;
}


.coach_kickstart_section {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 5px;
  padding-bottom: 5px;
  background-image: url('https://res.cloudinary.com/ilovekickboxing/image/upload/v1755549213/gold_scribble_dabua4.png');
  background-repeat: no-repeat;
  background-position: top right;
}
</style>